import axios from "axios";

function BranchAdminDropdown() {
  return new Promise((resolve, reject) => {
    axios
      .get("/account/api/v1/nodes/stockflow-me-bottom-dropdown-special")
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default BranchAdminDropdown;
